


















































































































































































































































































































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { DocConvenzione } from "../../_models/docConvenzione";
import { bus } from "../../main";
import * as user from "../../_store/user.module";
import Axios from "axios";

@Component
export default class ConvenzioneTirEstivoSign extends Vue {
  @Prop() docInfo!: DocConvenzione;
  @Prop() soggetto!: string;
  private firmaAzienda: string;
  private input: string

  constructor() {
    super();
    this.firmaAzienda = "";
    this.input = ""
  }

  get testHtml(){
    return this.input;
  }

  loadHtml(){
    Axios({
      method: "get",
      url: "http://localhost:8181/testHtml"
    }).then(result => {
      this.input = result.data
    }).catch(error =>{
      console.error("error")
    })
    // this.input += "<v-row>"
    // this.input +="<v-col>"
    // this.input +="<p>"
    // this.input += "Per tutto quanto non previsto dalla presente Convenzione le parti fanno riferimento alla legislazione vigente."
    // this.input +="</p>"
    // this.input +="</v-col>"
    // this.input +="<v-col>"
    // this.input +="<p>"
    // this.input +="Prova di inserimento"
    // this.input +="</p>"
    // this.input +="<h3>Art. 12. Trattamento dati personali</h3>"
    // this.input +="</v-col>"
    // this.input +="<v-col style='padding: 5px'>"
    // this.input +="<h3>TEST Trattamento dati personali</h3>"
    // this.input +="</v-col>"
    // this.input +="</v-row>"

    // this.input += "<v-row>"
    // this.input +="<v-col>"
    // this.input +="<p>"
    // this.input +="<b>Nato/a a:</b> Vicoforte"
    // this.input +="</p>"
    // this.input +="</v-col>"
    // this.input +="</v-row>"

    // this.input +="<v-row style='padding: 5px'>"
    // this.input +="<v-col>"
    // this.input +="<table style='border:1px solid black; border-collapse: collapse;'>"
    // this.input +="<tr>"
    // this.input +="<td class='font-weight-bold' style='padding: 5px; text-align: left'>Nato/a a</td>"
    // this.input +="<td style='padding: 5px; text-align: left'>denominazione</td>"
    // this.input += "</tr>"
    // this.input +="<tr>"
    // this.input +="<td class='font-weight-bold' style='padding: 5px; text-align: left'>Dirigente Scolastico / Legale Rappresentante</td>"
    // this.input +="<td style='padding: 5px; text-align: left'>Dott. Paolo Cortese</td>"
    // this.input += "</tr>"
    // this.input +="</table>"
    // this.input +="</v-col>"
    // this.input +="</v-row>"

    // this.input += "<v-row style='padding: 5px'>"
    // this.input +="<ul>"
    // this.input +="<li>dati identificativi del soggetto promotore e del tutor o referente;</li>"
    // this.input +="</ul>"
    // this.input +="</v-row>"
              
  }

  clearEnterpriseSignature() {
    //@ts-ignore
    this.$refs.enterpriseSignaturePad.clearSignature();
  }

  close() {
    bus.$emit("closeDocSignDialog");
    // bus.$emit("closeConvenzione");
  }

  save() {
    //dispatchSignConvenzione
    var signatureAziendaEmpty: boolean = true;
    //@ts-ignore
    const signatureAzienda = this.$refs.enterpriseSignaturePad.saveSignature();
    if (signatureAzienda.isEmpty === false) {
      const payload = {
        idConvenzione: this.docInfo.idConvenzione,
        firmaAzienda: signatureAzienda.data
      };

      user
        .dispatchSignConvenzione(this["$store"], payload)
        .then(() => {
          bus.$emit("successfullOperation", "Convenzione Firmata con successo");
          bus.$emit("loadConvenzione");
          this.close();
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    } else {
      bus.$emit("errorOperation", "Firma Legale Rappresentante mancante");
    }
  }

  created(){
    this.loadHtml()
  }
}
